import NotificationBannerStorage from './NotificationBannerStorage';

export default class NotificationBanner {
    static #instance: NotificationBanner | null = null;

    readonly #storage: NotificationBannerStorage = new NotificationBannerStorage();

    readonly #banner: HTMLElement | null = document.querySelector(
        '[data-role="notification-banner"]'
    );

    readonly #bannerId: string = this.#banner?.dataset.bannerId ?? '';

    readonly #dismiss = (): void => {
        if (this.#banner === null) {
            return;
        }

        this.#banner.hidden = true;

        this.#storage.markAsDismissed(this.#bannerId).catch((): void => undefined);
    };

    private constructor() {
        if (this.#banner === null || this.#bannerId === '') {
            return;
        }

        this.#banner
            .querySelector('[data-role="notification-banner-close"]')
            ?.addEventListener('click', this.#dismiss);

        this.#showWhenNotDismissed().catch((): void => undefined);
    }

    public static getInstance(): NotificationBanner {
        if (NotificationBanner.#instance === null) {
            NotificationBanner.#instance = new NotificationBanner();
        }

        return NotificationBanner.#instance;
    }

    public static destroyInstance(): void {
        NotificationBanner.#instance = null;
    }

    async #showWhenNotDismissed(): Promise<void> {
        if (this.#banner === null) {
            return;
        }

        try {
            await this.#storage.removeDismissalsExcept(this.#bannerId);

            if (await this.#storage.isDismissed(this.#bannerId)) {
                return;
            }
        } catch {
            // Without storage the dismissal is unknown, so the banner is shown.
        }

        this.#banner.hidden = false;
    }
}
